import React, { Component } from 'react'
import { Button, Modal, ModalBody, ModalHeader, Label, Col, Row, Form, FormGroup, Input, Progress } from 'reactstrap'
import PropTypes from 'prop-types'
import ConvertInput from '../EventLog/ConvertInput'
import LengthInput from '../EventLog/LengthInput'
import CreatableSelect from '../Wps/CreatableSelect'
import { createOrUpdateLogMutation, WeldingLogDataFetchQuery, WeldingLogAllWeldersFetchQuery } from '../EventLog/mutations'
import { graphql, compose, withApollo } from 'react-apollo'
import gql from 'graphql-tag'
import BlockWithLoader from '../Support/BlockWithLoader'
// import {withGaTracker, withGaEvent} from '../Support/GoogleAnalytics'
import FilterWeldersSwitch from './helpers/FilterWeldersSwitch'

class WeldingLogModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      log_data_input: [{ additional_name: '', additional_value: '' }],
      type: 'WlWelds::Logs::Welding',
      person_id: null,
      welding_consumables: [],
      wps_ids: [],
      wps_list: [],
      validationErrors: null,
      welders_by_qualifications: null,
      people_list: [],
      isSubmitting: false
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleOnSelectWeldingLogChange = this.handleOnSelectWeldingLogChange.bind(this)
    this.handleDeleteInput = this.handleDeleteInput.bind(this)
    this.handleAddDynamicInput = this.handleAddDynamicInput.bind(this)
    this.handleSelectValueChange = this.handleSelectValueChange.bind(this)
    this.handleLogTypeChange = this.handleLogTypeChange.bind(this)
    this.handleConsumablesChange = this.handleConsumablesChange.bind(this)
    this.handleWpsToggle = this.handleWpsToggle.bind(this)
  }

  static propTypes = {
    client: PropTypes.object.isRequired,
    createOrUpdateLogMutation: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    isOpened: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    afterSubmit: PropTypes.func.isRequired,
    weldsData: PropTypes.array.isRequired,
    editData: PropTypes.object,
  }

  componentDidMount() {
    // withGaTracker(window.location.pathname + '/welding_log_form') // GA TRACKER
  }

  componentWillMount() {
    if (!localStorage.getItem('weldsGridFilterWelders') || localStorage.getItem('weldsGridFilterWelders') === 'false') {
      this.fetchAllWelders()
    }

    this.fillFormLogDataFromProps(this.props)
    this.setWpsListFromWeld()
  }

  componentWillReceiveProps(newProps) {
    this.fillFormLogDataFromProps(newProps)
    this.setWpsListFromWeld(newProps)
  }

  setWpsListFromWeld(props = this.props) {
    const welds = props.weldsData
    if (!welds || welds.length === 0) return

    if (welds.length === 1) {
      const wps_list = welds[0].wps || []
      const defaultIds = props.editData ? (props.editData.wps_ids || []) : wps_list.map(w => Number(w.id))
      this.setState({ wps_list, wps_ids: defaultIds })
    } else {
      // czesc wspolna WPS po id
      const allWpsArrays = welds.map(w => (w.wps || []).map(p => Number(p.id)))
      const commonIds = allWpsArrays.reduce((acc, ids) => acc.filter(id => ids.includes(id)))
      const wps_list = (welds[0].wps || []).filter(p => commonIds.includes(Number(p.id)))
      this.setState({ wps_list, wps_ids: wps_list.map(w => Number(w.id)) })
    }
  }

  fetchAllWelders(permissionKey = 'core.people.welder') {
    if (permissionKey === 'core.people.welder' && this.props.weldsData.length === 1) {
      // Zbierz wszystkie standardy certyfikacji z WPS spoiny (uniq)
      const allStandards = []
      if (this.props.weldsData[0].wps) {
        this.props.weldsData[0].wps.forEach(wps => {
          if (wps.welder_certification_standards) {
            allStandards.push(...wps.welder_certification_standards)
          }
        })
      }
      let uniqueStandards = [...new Set(allStandards)]
      if (uniqueStandards.length === 0) {
        uniqueStandards = [0]
      }

      // Zawsze używaj filtra z WPS standardami
      const dateInput = document.querySelector('input[name="date"]')
      const now = new Date()
      let weldingDate
      if (dateInput && dateInput.value) {
        const [datePart, timePart] = dateInput.value.split('T')
        weldingDate = `${datePart} ${timePart || '00:00'}`
      } else {
        const year = now.getFullYear()
        const month = String(now.getMonth() + 1).padStart(2, '0')
        const day = String(now.getDate()).padStart(2, '0')
        weldingDate = `${year}-${month}-${day} 00:00`
      }

      this.props.client.query({
        query: WeldingLogAllWeldersFetchQuery,
        fetchPolicy: 'network-only',
        variables: {
          filters: {
            permission_key: 'core.people.welder',
            active: 'true',
            wps_welder_certification_standards: {
              welder_certification_standards: uniqueStandards,
              welding_date: weldingDate
            }
          }
        }
      }).then(({ data: { people } }) => {
        let people_list = people.list.slice(0)
        this.props.editData && !people_list.find(o => o.id === this.props.editData.person.id) && people_list.push(this.props.editData.person)
        this.setState({ people_list: people_list })
      })
    } else {
      this.props.client.query({
        query: WeldingLogAllWeldersFetchQuery,
        fetchPolicy: 'network-only',
        variables: { filters: { permission_key: permissionKey, active: 'true' } }
      }).then(({ data: { people } }) => {
        let people_list = people.list.slice(0)
        this.props.editData && !people_list.find(o => o.id === this.props.editData.person.id) && people_list.push(this.props.editData.person)
        this.setState({ people_list: people_list })
      })
    }
  }



  fillFormLogDataFromProps(props) {
    if (props.editData) {
      let log_data = JSON.parse(props.editData.log_data) || {}
      let log_input_data = []
      for (const [k, v] of Object.entries(log_data)) {
        log_input_data.push({ additional_name: k, additional_value: v })
      }
      this.setState({
        log_data_input: log_input_data,
        person_id: props.editData.person.id,
        type: props.editData.type,
        welding_consumables: props.editData.welding_consumables ? props.editData.welding_consumables.map(c => c.name) : [],
        wps_ids: props.editData.wps_ids && props.editData.wps_ids.length > 0
          ? props.editData.wps_ids.map(Number)
          : (props.editData.wps ? props.editData.wps.map(w => Number(w.id)) : [])
      })
    }
  }

  handleSubmit(event) {
    event.preventDefault()
    if (!this.state.person_id) {
      return this.setState({ validationErrors: [{ weld_no: this.props.weldsData[0].no, errors: ['Please select Person'] }] })
    }
    if (this.state.type === 'WlWelds::Logs::Welding' && this.state.wps_list.length > 0 && this.state.wps_ids.length === 0) {
      return this.setState({ validationErrors: [{ weld_no: this.props.weldsData[0].no, errors: ['Please select at least one WPS'] }] })
    }
    if (this.state.isSubmitting) return

    this.setState({ isSubmitting: true })
    const form_elements = event.target.elements
    const dateValue = form_elements.date.value
    const formattedDate = (() => {
      const [datePart, timePart] = dateValue.split('T')
      const [year, month, day] = datePart.split('-')
      return `${day}.${month}.${year} ${timePart || '00:00'}`
    })()

    this.props.createOrUpdateLogMutation({
      variables: {
        id: this.props.editData ? this.props.editData.id : null,
        date: formattedDate,
        note: form_elements.note.value,
        type: this.state.type,
        log_data: this.preparedLogDataTypes(),
        complete_percent: String(form_elements.complete_percent.value),
        complete: form_elements.complete ? Number(form_elements.complete.value) : null,
        welds_id: this.props.weldsData.map(weld => Number(weld.id)),
        person_id: this.state.person_id,
        welding_consumables: this.state.welding_consumables,
        wps_ids: this.state.type === 'WlWelds::Logs::Welding' ? this.state.wps_ids : null
      },
    }).then(({ data }) => {
      let logsErrors = []
      data.createOrUpdateLogs.logs.forEach(obj => {
        if (obj.errors && obj.errors.length > 0) {
          logsErrors.push({ weld_no: obj.weld.no, errors: obj.errors })
        }
      })

      if (logsErrors.length > 0) {
        // withGaEvent({category: 'WeldingLog', action: ' error save'}) // GA EVENT
        this.setState({ validationErrors: logsErrors, isSubmitting: false })
      } else {
        // withGaEvent({category: 'WeldingLog', action: 'save'}) // GA EVENT
        this.setState({ isSubmitting: false })
        this.props.afterSubmit(data.createOrUpdateLogs.logs)
      }
    }).catch((error) => {
      console.error('GraphQL mutation error:', error)
      this.setState({ isSubmitting: false })
    })
  }

  preparedLogDataTypes() {
    let zm = {}
    this.state.log_data_input.forEach(ar => {
      if (ar.additional_name !== '') {
        zm[ar.additional_name] = ar.additional_value
      }
    })
    return JSON.stringify(zm)
  }

  handleOnSelectWeldingLogChange(event, idx) {
    let newValue = this.state.log_data_input
    newValue[idx][event.target.name] = event.target.value
    this.setState({ log_data_input: newValue })
  }

  setSelectWeldingLogOptions() {
    if (this.props.data.welding_log_data_types) {
      return this.props.data.welding_log_data_types.map((weld_log, idx) => {
        return (<option key={idx} value={weld_log.id}>{weld_log.name}</option>)
      })
    }
  }

  handleDeleteInput(idx) {
    let newValue = this.state.log_data_input
    this.setState({ log_data_input: newValue.filter((s, sidx) => idx !== sidx) })
  }

  handleAddDynamicInput() {
    let newValue = this.state.log_data_input
    newValue.push({ additional_name: '', additional_value: '' })
    this.setState({ log_data_input: newValue })
  }

  handleSelectValueChange(person) {
    this.setState({ person_id: person && person.id })
  }

  handleLogTypeChange(event) {
    const newType = event.target.value
    const permissionKey = newType === 'WlWelds::Logs::Grinding' ? 'core.people.grinder' : 'core.people.welder'

    this.setState({ type: newType, person_id: null })
    this.fetchAllWelders(permissionKey)
  }

  handleConsumablesChange(values) {
    if (!values) {
      this.setState({ welding_consumables: [] })
      return
    }
    const consumables = Array.isArray(values) 
      ? values.map(v => {
          if (typeof v === 'string') return v
          if (v.name) return v.name
          return v
        })
      : []
    this.setState({ welding_consumables: consumables })
  }

  handleWpsToggle(id) {
    const { wps_ids } = this.state
    const numId = Number(id)
    this.setState({
      wps_ids: wps_ids.includes(numId) ? wps_ids.filter(x => x !== numId) : [...wps_ids, numId]
    })
  }

  getConsumablesValue() {
    return this.state.welding_consumables.map(name => ({ name }))
  }

  render() {
    if (this.props.data.error) return <div>An unexpected error occurred</div>

    return (
      <BlockWithLoader loading={this.props.data.loading} renderChildren={true}>
        <Modal isOpen={this.props.isOpened} backdrop={this.state.isSubmitting ? 'static' : true} keyboard={!this.state.isSubmitting}>
          <ModalHeader>Welding Log</ModalHeader>
          <ModalBody>
            <Form id="welding-log-form" className="FormClassLabel" onSubmit={this.handleSubmit}>
              <FormGroup>
                <Label>Type</Label>
                <Input
                  type="select"
                  name="type"
                  value={this.state.type}
                  onChange={this.handleLogTypeChange}
                >
                  <option value="WlWelds::Logs::Welding">Welding</option>
                  <option value="WlWelds::Logs::Grinding">Grinding</option>
                </Input>
              </FormGroup>
              <CreatableSelect
                id="select-person-welding-log-form"
                label={<label>{this.state.type === 'WlWelds::Logs::Grinding' ? 'Person (grinder)' : 'Person (welder)'}
                  {this.state.type !== 'WlWelds::Logs::Grinding' &&
                    <FilterWeldersSwitch
                      weld_id={Number(this.props.weldsData[0].id)}
                      updateWeldersData={(welders) => {
                        welders === null && this.fetchAllWelders()
                        this.setState({ welders_by_qualifications: welders })
                      }}
                    />
                  }
                </label>}
                options={this.state.type === 'WlWelds::Logs::Welding' && this.state.welders_by_qualifications ? this.state.welders_by_qualifications : this.state.people_list}
                valueKey="id"
                value={this.state.person_id}
                multi={false}
                creatable={false}
                valueChangeFunction={this.handleSelectValueChange}
              />
              <FormGroup>
                <Label>Date</Label>
                <Input
                  id="date-welding-log-form"
                  type="datetime-local"
                  name="date"
                  defaultValue={(this.props.editData && this.props.editData.date && (() => {
                    const [datePart, timePart] = this.props.editData.date.split(' ')
                    const [day, month, year] = datePart.split('.')
                    return `${year}-${month}-${day}T${timePart || '00:00'}`
                  })()) || (() => {
                    const now = new Date()
                    const year = now.getFullYear()
                    const month = String(now.getMonth() + 1).padStart(2, '0')
                    const day = String(now.getDate()).padStart(2, '0')
                    return `${year}-${month}-${day}T00:00`
                  })()}
                  onChange={(e) => {
                    if (this.state.type === 'WlWelds::Logs::Welding') {
                      this.fetchAllWelders('core.people.welder')
                    }
                  }}
                  required
                />
              </FormGroup>
              {this.state.type === 'WlWelds::Logs::Welding' && this.state.wps_list.length > 0 &&
                <FormGroup>
                  <Label>WPS</Label>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {this.state.wps_list.map(wps => (
                      <label key={wps.id} style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer', marginBottom: 0 }}>
                        <input
                          type="checkbox"
                          checked={this.state.wps_ids.includes(Number(wps.id))}
                          onChange={() => this.handleWpsToggle(wps.id)}
                        />
                        {wps.no}
                      </label>
                    ))}
                  </div>
                </FormGroup>
              }
              <LengthInput
                my_value={Number(this.props.weldsData[0].length)}
                existingValue={this.props.editData ? this.props.editData.complete : null}
                defaultValue={
                  this.props.editData ? this.props.editData.complete_percent : (100 - (Number(this.props.weldsData[0].welding_progress) || 0))
                }
                multipleWelds={this.props.weldsData.length > 1}
              />
              <CreatableSelect
                id="select-welding-consumables"
                label="Welding Consumables"
                options={this.props.data.welding_consumables || []}
                valueKey="name"
                labelKey="name"
                value={this.getConsumablesValue()}
                multi={true}
                creatable={true}
                valueChangeFunction={this.handleConsumablesChange}
              />
              <Label>Additional parameters</Label>
              {this.state.log_data_input.map((inputRecordData, idx) => {
                return (
                  <div key={idx}>
                    <Row>
                      <Col xs="12" sm="5">
                        <Input
                          type="select"
                          name="additional_name"
                          value={inputRecordData.additional_name || ''}
                          onChange={(event) => {
                            this.handleOnSelectWeldingLogChange(event, idx)
                          }}
                        >
                          <option />
                          {this.setSelectWeldingLogOptions()}
                        </Input>
                      </Col>
                      <Col xs="12" sm="5">
                        <Input
                          type="text"
                          name="additional_value"
                          value={inputRecordData.additional_value || ''}
                          onChange={(event) => {
                            this.handleOnSelectWeldingLogChange(event, idx)
                          }}
                        />
                      </Col>
                      <Col sm="1">
                        <Button
                          color="danger"
                          onClick={() => {
                            this.handleDeleteInput(idx)
                          }}
                        >
                          <i className="fa fa-minus" />
                        </Button>
                      </Col>
                    </Row>
                  </div>
                )
              })}
              <Row>
                <Col sm="1">
                  <Button
                    color="primary"
                    onClick={this.handleAddDynamicInput}
                    style={{ marginTop: '10px' }}
                  >
                    <i className="fa fa-plus" />
                  </Button>
                </Col>
              </Row>
              <Label>Note</Label>
              <Input
                type="textarea"
                name="note"
                defaultValue={(this.props.editData && this.props.editData.note) || ''}
              />
              {this.state.validationErrors &&
                this.state.validationErrors.map((obj, i) => <h4 key={i} className="errors-heading ">
                  {`Weld No: ${obj.weld_no} -> ${obj.errors.join(', ')}`}
                </h4>)
              }
              <FormGroup>
                <hr />
                <Button id="cancel-welding-log-form-btn" className="float-right" color="danger" onClick={this.props.onCancel} disabled={this.state.isSubmitting}>Cancel</Button>
                <Button id="save-welding-log-form-btn" className="float-right" color="primary" type="submit" disabled={this.state.isSubmitting}>{this.state.isSubmitting ? 'Saving...' : 'Save'}</Button>
              </FormGroup>
            </Form>
          </ModalBody>
        </Modal>
      </BlockWithLoader>
    )
  }
}

const LogsModalWithMutations = compose(
  graphql(WeldingLogDataFetchQuery, { options: { fetchPolicy: 'network-only' } }),
  graphql(createOrUpdateLogMutation, { name: 'createOrUpdateLogMutation' })
)(WeldingLogModal)

export default withApollo(LogsModalWithMutations)



// WEBPACK FOOTER //
// ./src/components/EventLog/WeldingLogModal.js